import { immutableBotCatalogSnapshot, type BotCatalogSnapshot } from './BotCatalog';

const REQUEST_TIMEOUT_MS = 5_000;

export async function fetchBotCatalogSnapshot(signal?: AbortSignal): Promise<BotCatalogSnapshot> {
  const timeout = AbortSignal.timeout(REQUEST_TIMEOUT_MS);
  const combined = signal ? AbortSignal.any([signal, timeout]) : timeout;
  let response: Response;
  try {
    const base = (import.meta.env.VITE_APP_SERVER_URL as string | undefined)?.trim() ?? '';
    response = await fetch(`${base}/api/bots`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: combined,
    });
  } catch (error) {
    throw new Error('Authoritative bot catalog is unavailable.', { cause: error });
  }
  if (!response.ok) throw new Error(`Authoritative bot catalog request failed (${response.status}).`);
  const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
  if (!contentType.includes('application/json')) throw new Error('Authoritative bot catalog returned a non-JSON response.');
  let payload: unknown;
  try {
    payload = await response.json();
  } catch (error) {
    throw new Error('Authoritative bot catalog returned invalid JSON.', { cause: error });
  }
  if (!payload || typeof payload !== 'object' || Array.isArray(payload) || !('catalog' in payload)) {
    throw new Error('Authoritative bot catalog response is invalid.');
  }
  return immutableBotCatalogSnapshot((payload as { catalog: unknown }).catalog);
}
